import React from 'react';
import styled from '@emotion/styled';
import { Global, css } from '@emotion/react';

// Components
import Navigation from '../Home/components/Navigation';
import TrustHero from './components/BlueprintHero';
import ClientTrust from './components/ClientTrustSection';
import FounderJourney from './components/FounderJourneySection';
import Footer from '../Landing/footer';
import LiveMetricsDashboard from './components/LiveMetricsDashboard';

// Global Styles
const GlobalStyles = () => (
    <Global
        styles={css`
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        `}
    />
);

// Styled Components
const Page = styled.div`
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    color: #111827;
    position: relative;
    overflow-x: hidden;
`;

const MainContent = styled.main`
    width: 100%;
`;

// Component
const Phase2Landing: React.FC = () => {
    return (
        <Page>
            <GlobalStyles />
            <Navigation />
            <MainContent>
                <TrustHero />
                <ClientTrust />
                <LiveMetricsDashboard />
                <FounderJourney />
            </MainContent>
            <Footer />
        </Page>
    );
};

export default Phase2Landing;
